/**************************************************
 * Nombre:       Tarjetas_Icono
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjetas_Icono = ({item, click, index}) => {


    return (
        <Grid
            onClick={() => click(item,index)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2, mt: 2, py:2}}
            spacing={1}
        >


            <Grid container size={8}>
                <Typography
                    sx={{ lineHeight: 1.2, fontSize: 16}}>{`${item.nombre}`}</Typography>
            </Grid>




        </Grid>
    )

}
export default Tarjetas_Icono